import { Star, Goal } from 'lucide-react';

export function VisionMision(): React.ReactElement {
  return (
    <section id="sobre" className="bg-background relative overflow-hidden py-16">
      <div className="relative z-10 container mx-auto px-6 lg:px-12 xl:px-16 2xl:px-24">
        <div className="mb-12 text-center">
          <h2 className="text-foreground mb-4 text-3xl font-bold lg:text-4xl">
            <span className="from-primary to-secondary bg-linear-to-r bg-clip-text text-transparent">
              Nuestra Visión y Misión
            </span>
          </h2>
          <p className="text-muted-foreground mx-auto max-w-3xl text-base leading-relaxed lg:text-lg">
            Trabajamos para fortalecer y consolidar el sistema de aseguramiento en salud,
            representando y defendiendo los intereses de nuestras asociadas.
          </p>
        </div>

        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div className="group relative">
            <div className="bg-card shadow-medium group-hover:border-primary/20 group-hover:shadow-strong relative overflow-hidden rounded-2xl border p-6 transition-all duration-500 group-hover:scale-105">
              <Star className="text-primary mb-3 h-8 w-8" />

              <h3 className="text-foreground mb-3 text-2xl font-bold">Misión</h3>
              <p className="text-muted-foreground text-base leading-relaxed">
                Representar y resguardar los intereses generales de sus asociadas ante las entidades
                públicas y privadas, nacionales e internacionales, actuando como defensora de sus
                derechos en el sector, así como, contribuyendo al fortalecimiento del sistema de
                aseguramiento en salud.
              </p>
            </div>
          </div>

          <div className="group relative">
            <div className="bg-card shadow-medium group-hover:border-secondary/20 group-hover:shadow-strong relative overflow-hidden rounded-2xl border p-6 transition-all duration-500 group-hover:scale-105">
              <Goal className="text-secondary mb-3 h-8 w-8" />

              <h3 className="text-foreground mb-3 text-2xl font-bold">Visión</h3>
              <p className="text-muted-foreground text-base leading-relaxed">
                Elevar el sistema de aseguramiento en salud, consolidando y unificando criterios
                entre todas sus asociadas, promoviendo un entorno de colaboración y eficiencia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
